export default "__VITE_ASSET__BZrGn0bh__"